module.exports = __webpack_public_path__ + "static/media/Palazzo Reale - White - DKGrey_Peri.ce240d34.jpg";